import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between w-full border-l-[10px] border-primary-400 mt-8 mb-8 text-2xl text-left font-extrabold pt-2 pb-2 pl-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Mis comunidades", -1)
const _hoisted_4 = { class: "flex flex-col md:flex-row justify-between relative" }
const _hoisted_5 = { class: "flex-3/4 place-items-center" }
const _hoisted_6 = { class: "flex-1/4" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_CommunityCard = _resolveComponent("CommunityCard")!
  const _component_ContactMe = _resolveComponent("ContactMe")!
  const _component_NewCommunityCard = _resolveComponent("NewCommunityCard")!
  const _component_CommunityRegister = _resolveComponent("CommunityRegister")!

  return (_ctx.authSuperUser?.isSuperuser || _ctx.authStore.userCommunity?.userRole == 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_SearchBox, {
            onSearchCommunity: _ctx.handleSearch,
            width: "w-72"
          }, null, 8, ["onSearchCommunity"])
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CommunityCard, {
              communities: _ctx.communities,
              onDeleteCommunity: _ctx.handleAccept
            }, null, 8, ["communities", "onDeleteCommunity"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ContactMe)
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _createVNode(_component_NewCommunityCard, {
            class: "absolute cursor-pointer mt-5",
            onClick: _ctx.openModalCreate
          }, null, 8, ["onClick"]),
          (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_CommunityRegister, {
                key: 0,
                visible: _ctx.showModal,
                action: 'create',
                onAccept: _ctx.handleAccept
              }, null, 8, ["visible", "onAccept"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, " No tienes autorización para ingresar a esta plataforma. solicita acceso a tu administrador "))
}